import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export function initSliders() {
  // Project slider
  const projectSlider = document.querySelector('.project-slider-001__slider');
  if (projectSlider) {
    new Swiper(projectSlider, {
      modules: [Autoplay],
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 100,
      loop: true,
      speed: 500,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.16,
        },
        500: {
          slidesPerView: 1.18,
        },
        769: {
          slidesPerView: 1.54,
        },
      },
    });
  }

  // List slider
  const listSlider = document.querySelector('.slider-list-001__slider');
  if (listSlider) {
    new Swiper(listSlider, {
      modules: [Pagination],
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true,
    });
  }
}
